import Icons, { IconsProps } from '../Icons';

// https://www.zhangxinxu.com/sp/svgo/

export default function (props: IconsProps) {
  return (
    <Icons {...props}>
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_11125_43796)">
          <path d="M10.1377 0H55.4252V64H10.1377V0Z" fill="white" />
          <path
            d="M-12.5 0H10.1375V64H-12.5V0ZM55.425 0H78.0625V64H55.425V0ZM16.9125 30.925L15.1625 31.525L23.3375 38.7125C23.9625 40.5625 23.125 41.1 22.5875 42.075L31.4625 40.95L31.2375 49.8875L33.0875 49.825L32.675 40.9625L41.575 42.0125C41.025 40.85 40.5375 40.2375 41.0375 38.3875L49.2125 31.575L47.7875 31.0625C46.6125 30.15 48.2875 26.7125 48.5375 24.5375C48.5375 24.5375 43.775 26.175 43.4625 25.3125L42.225 23L37.9 27.75C37.425 27.875 37.225 27.675 37.1125 27.275L39.1125 17.3125L35.9375 19.1C35.675 19.2125 35.4125 19.1 35.2375 18.8L32.175 12.675L29.025 19.0375C28.7875 19.2625 28.55 19.2875 28.35 19.1375L25.325 17.4375L27.1375 27.3375C27 27.7125 26.65 27.8375 26.25 27.625L22.0875 22.9C21.55 23.775 21.175 25.2 20.4625 25.525C19.75 25.8125 17.3375 24.9125 15.725 24.5625C16.275 26.55 18 29.85 16.9125 30.9375V30.925Z"
            fill="#D52B1E"
          />
        </g>
        <defs>
          <clipPath id="clip0_11125_43796">
            <rect width="64" height="64" rx="32" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Icons>
  );
}
